<template>
  <div>
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      <strong>{{snackbarMsg}}</strong>
      <v-btn dark text @click="showSnackbar = false">
        <strong>CLOSE</strong>
      </v-btn>
    </v-snackbar>

    <v-app-bar color="white" class="px-4">
      <div class="logo">
        <a href="https://www.accelefreight.com" class="navbar-brand logo">
          <img src="@/assets/logo.svg" alt="AcceleFreight" width="100px" />
        </a>
      </div>
      <v-divider vertical inset></v-divider>

      <v-spacer></v-spacer>

      <v-btn
        class="font-weight-bold subtitle-2 d-none d-sm-flex"
        style="text-decoration: none;"
        text
        href="https://wa.me/60128208565"
      >
        <v-icon color="primary" left>mdi-phone</v-icon>+60 12 820 8565
      </v-btn>

      <v-btn
        depressed
        tile
        style="text-decoration: none;"
        color="primary"
        class="font-weight-bold"
        :to="{name: 'login'}"
      >SIGN IN</v-btn>
    </v-app-bar>

    <v-row no-gutters>
      <v-col>
        <v-window v-model="step">
          <!-- Step 1: Input credentials -->
          <v-window-item :value="1">
            <section class="container-fluid signup-wrap">
              <div class="row">
                <div class="col-lg-8 col-12 signup-intro">
                  <h1>Create your account</h1>
                  <p>
                    Please enter the following required information for your
                    registration. Your e-mail will be used as your username when you
                    login. Password must be at least 8 characters and contain at
                    least one upper case letter, one lower case letter and one
                    number.
                  </p>
                </div>
              </div>

              <div class="row signup-form">
                <div class="col-12 col-sm-4">
                  <div class="form-card form-group">
                    <label for="inputFirstName">First Name</label>
                    <input
                      type="text"
                      class="form-control"
                      id="inputFirstName"
                      placeholder="Eg: John"
                      v-model="credentials.first_name"
                    />
                  </div>
                </div>
                <div class="col-12 col-sm-4">
                  <div class="form-card form-group">
                    <label for="inputLastName">Last Name</label>
                    <input
                      type="text"
                      class="form-control"
                      id="inputLastName"
                      placeholder="Eg: Doe"
                      v-model="credentials.last_name"
                    />
                  </div>
                </div>
              </div>
              <div class="row signup-form">
                <div class="col-12 col-sm-4">
                  <div class="form-card form-group">
                    <label for="inputPhone">Phone number</label>
                    <input
                      type="text"
                      class="form-control"
                      id="inputPhone"
                      placeholder="Eg: 60123456789"
                      v-model="credentials.phone_number"
                    />
                  </div>
                </div>
                <div class="col-12 col-sm-4">
                  <div class="form-card form-group">
                    <label for="inputEmail"
                      >Email (to be used as login username)</label
                    >
                    <input
                      type="email"
                      class="text-lowercase form-control"
                      id="inputEmail"
                      placeholder="Eg: john.doe@gmail.com"
                      v-model="credentials.email"
                    />
                  </div>
                </div>
              </div>
              <div class="row signup-form">
                <div class="col-12 col-sm-4">
                  <div class="form-card form-group">
                    <label for="inputPassword1">Password</label>
                    <input
                      type="password"
                      class="form-control"
                      id="inputPassword1"
                      placeholder="Enter here"
                      v-model="credentials.password"
                    />
                  </div>
                </div>
                <div class="col-12 col-sm-4">
                  <div class="form-card form-group">
                    <label for="inputPassword2">Re-enter password</label>
                    <input
                      type="password"
                      class="form-control"
                      id="inputPassword2"
                      placeholder="Enter here"
                      v-model="credentials.password_repeat"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <vue-recaptcha
                    ref="recaptcha"
                    @verify="onVerify"
                    @expired="onExpired"
                    :sitekey="sitekey"
                  ></vue-recaptcha>
                </div>
                <div class="col-6">
                  <button
                    class="header-btn"
                    :disabled="!reCaptchaStatus"
                    @click="onNext"
                  >
                    Continue
                  </button>
                  &nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </section>
          </v-window-item>
          <!-- Step 2: Company details -->
          <v-window-item :value="2">
            <section class="container-fluid signup-wrap">
              <div class="row">
                <div class="col-lg-8 col-12 signup-intro">
                  <!-- <div class="steps">Step 2 of 3</div> -->
                  <h1>Fill in your company details</h1>
                  <p>
                    Your account was successfully registered.
                    <br />
                    <br />For the next step, we will require some information on
                    your company or the company you represent. <br />AcceleFreight
                    can only provide its services to an officially registered
                    company as required by international regulations. <br />You may
                    skip this process now and register your company at a later time.
                    However, we cannot confirm bookings on your shipment until the
                    company registration process is complete.
                  </p>
                </div>
              </div>

              <div class="row signup-form">
                <div class="col-12 col-sm-4">
                  <div class="form-card form-group">
                    <label for="companyNameInput">Company Name</label>
                    <input
                      type="text"
                      class="form-control"
                      id="companyNameInput"
                      placeholder="Eg: Company A Sdn Bhd"
                      v-model="company.name"
                    />
                  </div>
                </div>
                <div class="col-12 col-sm-4">
                  <div class="form-card form-group">
                    <label for="companyRegistrationInput"
                      >Company Registration Number</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="companyRegistrationInput"
                      placeholder="Eg: 12345678-T"
                      v-model="company.registration_number"
                    />
                  </div>
                </div>
              </div>

              <div class="row signup-form">
                <div class="col-12 col-sm-4">
                  <div class="form-card form-group">
                    <label for="companyPhoneNumberInput"
                      >Company phone number</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="companyPhoneNumberInput"
                      placeholder="Eg: 601234456789"
                      v-model="company.contact_info.phone"
                    />
                  </div>
                </div>

                <!-- <div class="col-12 col-sm-4">
                  <div class="form-card form-group">
                    <label for="companyPhoneNumberInput">Country</label>
                    <v-autocomplete
                      class="form-control"
                      :items="sortedCountriesList"
                      v-model="company.address.code_country"
                      item-value="code"
                      item-text="name"
                      clearable
                    ></v-autocomplete>
                  </div>
                </div>-->
              </div>

              <div class="row">
                <div class="col-12">
                  <button class="header-btn" @click="onNext">Continue</button>
                  <button class="skip-btn" @click="onStep2Skip">Skip</button>
                  &nbsp;&nbsp;&nbsp;
                  <span v-if="step2ErrorMsg != null" style="color: red">{{
                    step2ErrorMsg
                  }}</span>
                </div>
              </div>
            </section>
          </v-window-item>
          <!-- Step 3: Registration complete -->
          <v-window-item :value="3">
            <section class="container-fluid signup-wrap">
              <div class="row">
                <div class="col-lg-8 col-12 signup-intro" style="text-align: left">
                  <!-- <div class="steps">Step 3 of 3</div> -->
                  <h1>Welcome to accelefreight!</h1>
                  <p>
                    Congratulations! You've almost completed the registration
                    process.
                    <br />
                    <br />You should receive an email with a link to confirm your
                    registration process. Please confirm your registration by
                    clicking on the link.
                    <br />
                    <span v-if="step2Status == 'CREATED'">
                      We will reach out to you should further validation be required
                      for your company registration.
                      <br />
                    </span>
                    <span v-else-if="step2Status == 'EXISTS'">
                      The company you registered already exists in our system. We
                      have assigned your account under the company and notified the
                      administrator for validation.
                      <br />
                    </span>
                    <span v-else>
                      Please be reminded that a company is required to be registered
                      with your account before bookings can be confirmed
                      <br />
                    </span>
                    <br />At the mean time, you can get a tour of our features or
                    start making arrangements for your next order.
                  </p>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <button class="header-btn">Onboarding tour</button>
                  <router-link :to="{ name: 'login' }">Get started now</router-link>
                </div>
              </div>
            </section>
          </v-window-item>
        </v-window>
      </v-col>
    </v-row>

    <v-footer padless dark>
      <v-card tile flat class="flex">
        <v-card-text class="primary text--white text-right font-weight-bold">
          &copy; Copyright AcceleFreight 2020
        </v-card-text>        
      </v-card>
    </v-footer>
  </div>
</template>

<script>
import firebase from "firebase/app"
import "firebase/auth"
import constant from "../const"
import VueRecaptcha from "vue-recaptcha"

  export default {
    components: {
      VueRecaptcha
    },
    data() {
      return {
        sitekey: "6LfM0aUUAAAAAAZggaKaEC1S028_ZI4qMotxM8o6",
        reCaptchaStatus: false,
        snackbarColor: "",
        showSnackbar: false,
        snackbarMsg: "",
        snackbarTimeout: 8000,
        step: 1,
        step1ErrorMsg: null,
        credentials: {
          uid: null,
          first_name: null,
          last_name: null,
          phone_number: null,
          account_type: "AFC", // CUSTOMER == AFC, AF Users = AFU, SUPPLIERS == AFS
          email: null,
          password: null,
          password_repeat: null
        },

        step2ErrorMsg: null,
        step2Status: null, // Status can be 'SKIP', 'EXISTS',  and 'CREATED'

        company: {
          uid: null,
          name: null,
          registration_number: null,
          preferred_currency: "MYR",
          address: {
            line_1: null,
            line_2: null,
            line_3: null,
            city: null,
            postcode: null,
            state: null,
            code_country: null
          },
          contact_info: {
            first_name: null,
            last_name: null,
            email: null,
            phone: null,
            notify: true
          },
          contact_person: []
        },
        countries: []
      }
    },

    created () {
    },

    mounted() {
      //this.$router.replace({name: 'terms&conditions'})
      this.$refs.recaptcha.reset()
    },

    watch: {
      
    },

    methods: {
    onNext() {
      switch (this.step) {
        case 1:
          this.onStep1()
          break
        case 2:
          this.onStep2()
          break
        default:
          break
      }
    },

    onStep1() {
      // this.step++;
      // // fetch countries
      // // this.loadCountriesList();
      // return;

      this.$root.blockUIshow = true
      try {
        if (
          this.credentials.email == null ||
          this.credentials.email == "" ||
          this.credentials.password == null ||
          this.credentials.password == ""
        ) {
          throw "Cannot create account with empty email or password"
        }
        if (this.credentials.password.length < 8) {
          throw "Password must contain at least 8 characters"
        }
        if (this.credentials.password != this.credentials.password_repeat) {
          throw "Both passwords must be identical"
        }
        var response = null
        // check email if user is a customer or af user
        if (this.credentials.email.match(/@accelefreight.com/g)) {
          throw "Registration here is only for Non-Accele Freight Users"
          // this.credentials.account_type = "AFU";
        }
        // parse email to lowercase
        this.credentials.email = this.credentials.email.toLowerCase()
        // update the company
        this.company.contact_info.email = this.credentials.email
        this.company.contact_info.phone = this.credentials.phone_number
        this.company.contact_info.first_name = this.credentials.first_name
        this.company.contact_info.last_name = this.credentials.last_name

        var postform = this.credentials
        // pass "this" to self
        var self = this
        // Register New User into Firebase Authentication
        // [START createwithemail]
        firebase
          .auth()
          .createUserWithEmailAndPassword(
            self.credentials.email,
            self.credentials.password
          )
          .then(function(userInfo) {
            // update the postform and credential
            self.credentials.uid = userInfo.user.uid
            self.company.uid = self.credentials.uid
            // get the current user and update user information
            var user = firebase.auth().currentUser
            // update the current user phone number and name
            user
              .updateProfile({
                displayName:
                  self.credentials.last_name + " " + self.credentials.first_name
              })
              .then(function() {
                //  register a company user
                self.$auth
                  .post("/user/company", self.credentials)
                  .then(resp => {
                    response = resp.data
                    // console.log("response:", response);
                    if (response.status == constant.RESPONSE_STATUS_OK) {
                      // [START sendemailverification]
                      user
                        .sendEmailVerification(constant.ACTION_CODE_SETTING)
                        .then(function() {
                          self.$root.blockUIshow = false
                          // Email Verification sent!
                          self.showSnackbar = true
                          self.snackbarColor = "success"
                          self.snackbarMsg =
                            "Email Verification Sent! Check your email"
                          // [END sendemailverification]
                          // go to the next step
                          self.step++
                        })
                    } else {
                      self.$root.blockUIshow = false
                      // console.log(response);
                      self.showSnackbar = true
                      self.snackbarColor = "error"
                      self.snackbarMsg = response.msg
                      // self.step1ErrorMsg = response.data.msg;
                      // delete user
                      user
                        .delete()
                        .then(function() {
                          // User deleted.
                        })
                        .catch(function(error) {
                          // An error happened.
                          // An error happened.
                          console.log("error:", error)
                        })
                    }
                  })
                  .catch(err => {
                    console.log("error:-> ", err)
                    self.$root.blockUIshow = false
                    self.showSnackbar = true
                    self.snackbarColor = "error"
                    self.snackbarMsg =
                      "Error connecting to server for registration. Please contact help@accelefreight.com to proceed."
                    // delete user
                    user
                      .delete()
                      .then(function() {
                        // User deleted.
                      })
                      .catch(function(error) {
                        // An error happened.
                        // An error happened.
                        console.log("error:", error)
                      })
                  })
              })
              .catch(function(error) {
                self.$root.blockUIshow = false
                // An error happened.
                self.showSnackbar = true
                self.snackbarColor = "error"
                self.snackbarMsg = error
                // delete user
                user
                  .delete()
                  .then(function() {
                    // User deleted.
                  })
                  .catch(function(error) {
                    // An error happened.
                    // An error happened.
                    console.log("error:", error)
                  })
              })
          })
          .catch(function(error) {
            self.$root.blockUIshow = false
            // Handle Errors here.
            self.showSnackbar = true
            self.snackbarColor = "error"
            self.snackbarMsg = error.message
          })
      } catch (error) {
        console.log("ERROR: ", error);
        this.$root.blockUIshow = false
        this.showSnackbar = true
        this.snackbarColor = "error"
        this.snackbarMsg = error
      }
    },

    /**
     * Step 2: Register Company information
     */
    onStep2() {
      try {
        if (this.company.name == null || this.company.name == "") {
          this.showSnackbar = true
          this.snackbarColor = "warning"
          this.snackbarMsg = "Cannot register a company with empty name"
          return
        }

        if (
          this.company.registration_number == null ||
          this.company.registration_number == ""
        ) {
          this.showSnackbar = true
          this.snackbarColor = "warning"
          this.snackbarMsg =
            "Cannot register a company with empty registration number"
          return
        }

        this.$root.blockUIshow = true

        // api call to register new company during signup
        this.$https
          .post("/api/company/register", this.company)
          .then(resp => {
            if (resp.data.status == constant.RESPONSE_STATUS_OK) {
              this.step2Status = "CREATED"
              this.$root.blockUIshow = false
              // go to the next step
              this.step++
            } else {
              this.showSnackbar = true
              this.snackbarColor = "warning"
              this.snackbarMsg = resp.data.msg
              this.$root.blockUIshow = false
            }
          })
          .catch(err => {
            this.showSnackbar = true
            this.snackbarColor = "error"
            this.snackbarMsg =
              "Error connecting to server for company registration. Please contact help@accelefreight.com to proceed."
            this.$root.blockUIshow = false
          })
      } catch (error) {
        this.showSnackbar = true
        this.snackbarColor = "error"
        this.snackbarMsg = error
        this.$root.blockUIshow = false
      }
    },

    onStep2Skip() {
      this.step2Status = "SKIP"
      this.step++
    },

    /** Verify reCAPTCHA */
    onVerify(responseToken) {
      const self = this
      console.log("VERIFIED")
      self.$root.blockUIshow = true
      // verify the response token
      this.$auth
        .post("/recaptcha", { token: responseToken })
        .then(res => {
          // console.log(res.data);
          if (res.data.status == "OK") {
            // enable the Continue button
            self.reCaptchaStatus = true
            self.$root.blockUIshow = false
          } else {
            // reset the recaptcha
            self.$refs.recaptcha.reset()
            // response token was not verified, because this user is not human
            // disable the Continue button
            self.reCaptchaStatus = false
            self.$root.blockUIshow = false
          }
        })
        .catch(err => {
          console.log("error: ", err)
          // reset the recaptcha
          self.$refs.recaptcha.reset()
          // disable the Continue button
          self.reCaptchaStatus = false
          self.$root.blockUIshow = false
        })
    },

    /** Expired reCAPTCHA */
    onExpired() {
      console.log("Expired!")
      this.reCaptchaStatus = false
      this.$refs.recaptcha.reset()
    },

    /** Reset reCAPTCHA */
    resetRecaptcha() {
      // this.$refs.recaptcha.reset(); // Direct call reset method
    }

    /**
     * Get country list
     */
    // loadCountriesList() {
    //   // block the ui
    //   this.$root.blockUImsg = "please wait...";
    //   this.$root.blockUIshow = true;

    //   this.$https.get("/api/countries").then(resp => {
    //     this.$root.blockUIshow = false;
    //     console.log("country: ", resp.data);

    //     if (resp.data.status == constant.RESPONSE_STATUS_OK) {
    //       this.countries = resp.data.data;
    //     } else {
    //       this.countries = [];
    //     }
    //   });
    // }
  },

  computed: {
    // sortedCountriesList: function() {
    //   return this.countries.sort(function(a, b) {
    //     return ("" + a.name).localeCompare(b.name);
    //   });
    // }
  }
     
  }
</script>

<style scoped>
.skip-btn {
  color: #1c6cf2;
  border: 2px solid #1c6cf2;
  width: 150px;
  padding: 14px 20px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 0px;
  -webkit-border-radius: 0px;
  -moz-border-radius: 0px;
  -ms-border-radius: 0px;
  -o-border-radius: 0px;
  transition: all ease-in 300ms;
  -webkit-transition: all ease-in 300ms;
  -moz-transition: all ease-in 300ms;
  -ms-transition: all ease-in 300ms;
  -o-transition: all ease-in 300ms;
}
</style>